// extracted by mini-css-extract-plugin
export default {"permissionForm":"permissionForm-KRj4p","treeBlock":"treeBlock-xqFZD"};